import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/modal';
import { Button } from '@/components/ui/button';
import { ButtonLoadable } from '@/components/ui/button-loadable';
import { ModalProps } from '@/hooks/use-modal';

interface NoIntegrationsConfirmationModalProps extends ModalProps {
  onConfirm: () => void;
  isLoading?: boolean;
}

export const NoIntegrationsConfirmationModal: FC<NoIntegrationsConfirmationModalProps> = ({
  onClose,
  onConfirm,
  isLoading = false,
  ...props
}) => {
  const { t } = useTranslation(['authenticated.onboarding.integrations']);

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal onClose={onClose} className="max-w-md" preventClose={isLoading} {...props}>
      <Modal.Title>{t('modals.noIntegrationsConfirmation.title')}</Modal.Title>

      <Modal.Body>
        <p className="text-sm text-muted-foreground">
          {t('modals.noIntegrationsConfirmation.description')}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
          {t('modals.noIntegrationsConfirmation.actions.cancel')}
        </Button>

        <ButtonLoadable type="button" onClick={handleConfirm} isLoading={isLoading}>
          {t('modals.noIntegrationsConfirmation.actions.skipAndContinue')}
        </ButtonLoadable>
      </Modal.Footer>
    </Modal>
  );
};
